import { openLoading, closeLoading } from './saas-loading-utils.js'
const fullscreenLoadingInstance = {
    open: undefined,
    close: () => {
        closeLoading(document.body)
    }
}
export default (options) => {
    if (Object.prototype.toString.call(options) !== '[object Object]') {
        options = {}
    }
    let ele = options?.fullscreen ? document.body : options?.target || document.body
    if (!ele) return
    if (ele === document.body) {
        options.fullscreen = true
    }
    openLoading(ele, options)
    if (options.fullscreen) {
        fullscreenLoadingInstance.open = () => {
            openLoading(ele, options)
        }
        return fullscreenLoadingInstance
    }
    return {
        open: () => {
            openLoading(ele, options)
        },
        close: () => {
            closeLoading(ele)
        }
    }
}
